import { ApiService, ApiServiceInterface } from "../../../../../core";
import { AdsListDataResponse } from "../../../site/interfaces";
import { AdsListPageController } from "../../core";

export class AdsListPageControllerImpl implements AdsListPageController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<AdsListDataResponse> {
        try {
            const response = await this.api.get('/ads-list');
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    // async showBankSlip(id: string): Promise<AdsListDataResponse> {
    //     try {
    //         const response = await this.api.get(`/subscription-user-bank-slip/${id}`);
    //         return response;
    //     } catch (error) {
    //         throw new Error("Method not implemented.");
    //     }
    // }

    // async updateAds(status: string, id: string): Promise<AdsListDataResponse> {
    //     try {
    //         const requestData = {};
    //         requestData['id'] = id;
    //         requestData['status'] = status;

    //         const response = await this.api.put(`/payment-update-status`, requestData);
    //         return response;
    //     } catch (error) {
    //         throw new Error("Method not implemented.");
    //     }
    // }

    async adsDelete(adsId: string): Promise<AdsListDataResponse> {
        try {
            return await this.api.delete(`/ads/${adsId}`);
        } catch (error) {
            return { success: false, response: [] };
        }
    }
}